import React, { Component } from 'react';
import { Link, NavLink, createSearchParams } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import {
  Popup, Icon, Progress, Loader, Modal, Checkbox, Dropdown
} from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import Update from 'immutability-helper';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { withTranslation } from 'react-i18next';
import $ from 'jquery';
import cx from 'classnames';
import api from '../../api';
import './Header.css';
import WithRouter from '../Extensions/WithRouter';
import ClarLoader from '../Loader/Loader';
import { SERVICE_DESK_LINK } from '../../constants/shared';
import { convertPropertiesToCamelCase } from '../../utils/shared';
import ScanNavBar from '../NavBar/ScanNavBar';
import logo from '../../images/common/header/Logo.png';
import alert from '../../images/common/header/GNB/alert (normal).png';
import profileBtn from '../../images/common/header/GNB/profile (normal).png';
import ScanProgress from '../../images/components/new_scan/oval.png';
import proifileImg from '../../images/components/profile/profile_icon_1.png';
import deleteIcon from '../../images/components/contnets_header/delete-icon-red.svg';

const notificationMenu = [
  'my_issue',
  'license',
  'oss_db',
  'oss_setting',
  'quota',
  'update_required',
  'uploaded_list'
];

class Header extends Component {
  constructor(props) {
    super(props);
    this.updateInterval = null;
    this.refreshInterval = null;
    this.updateNotiInterval = null;
    this.headerBody = null;

    this.setHeaderBodyRef = (element) => {
      this.headerBody = element;
    };
    const { state } = this.props;

    this.state = {
      pageSize: 10,
      currentPage: 1,
      isOpenScan: false,
      isOpenProfile: false,
      isOpenScanList: false,
      isShowScanStatus: false,
      isOpenPopup: false,
      isModalLoader: false,
      isModalError: false,
      isLoadingNoti: false,
      itemsChecked: false,
      scanningText: null,
      isLoading: false,
      isLoadingStatus: false,
      isNewNotification: state.user.new_notification,
      isOpenNotification: false,
      error: null,
      hasMore: true,
      count: '',
      scanningStatus: [],
      checkValue: [],
      notificationList: [],
      totalCount: 0,
      currentLocale: '',
      localeList: [],
    };
    this.handleProfile = this.handleProfile.bind(this);
    this.handleScanList = this.handleScanList.bind(this);
    this.handleRemoveReport = this.handleRemoveReport.bind(this);
    this.handleCheckAll = this.handleCheckAll.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleScanOpen = this.handleScanOpen.bind(this);
    this.handleScanClose = this.handleScanClose.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleNotificationChange = this.handleNotificationChange.bind(this);
    this.handleFilteredUploadedList = this.handleFilteredUploadedList.bind(this);
    this.handleNavEvent = this.handleNavEvent.bind(this);
    this.handleLocaleChange = this.handleLocaleChange.bind(this);
    this.deleteReport = this.deleteReport.bind(this);
    this.getScanningStatus = this.getScanningStatus.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeScanningModal = this.closeScanningModal.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseover', '.new_scan_popup .scanning_files_wrap .scanning_files .scanning_files_table span', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
    if (this.headerBody) {
      this.onUpdateLoading();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { location, state } = this.props;
    const {
      isOpenScan, isOpenNotification, isOpenScanList, isLoading, isOpenProfile, currentLocale
    } = this.state;

    if (prevProps.location.pathname !== location.pathname) {
      const shouldUpdateState = this.headerBody && (isOpenScanList || isOpenProfile);
      const shouldInitURLParams = location.search === '';

      if (shouldUpdateState || shouldInitURLParams) {
        this.setState({
          ...shouldUpdateState ? { isOpenScanList: false, isOpenProfile: false } : {},
        }, () => {
          if (shouldInitURLParams) {
            state.pages.initURLparams();
          }
        });
      }
    }

    if (isOpenScan !== prevState.isOpenScan && !isOpenScan) {
      this.onUpdateStop();
      this.getScanningText();
    }

    if (isOpenScanList !== prevState.isOpenScanList) {
      if (isOpenScanList) {
        this.onRefreshStart();
      } else {
        this.onRefreshStop();
      }
    }

    if (isOpenNotification !== prevState.isOpenNotification) {
      if (isOpenNotification) {
        this.onUpdateNotiStop();
      } else {
        this.onUpdateNotiStart();
      }
    }

    if (!prevState.isLoading && isLoading) {
      this.getScanningText();
      this.onUpdateNotiStart();
      this.getUserLocaleValue();
    }

    if (currentLocale !== state.user.localeParams && state.user.localeParams !== '') {
      this.setState({
        currentLocale: state.user.localeParams,
      });
    }
  }

  componentWillUnmount() {
    this.onUpdateStop();
    this.onRefreshStop();
    this.onUpdateNotiStop();
  }

  handleScanOpen() {
    this.setState({
      isOpenScan: true,
      isOpenScanList: false,
      isOpenProfile: false,
      scanningStatus: [],
      count: '',
      itemsChecked: false,
      checkValue: [],
    });
  }

  handleScanClose() {
    this.setState({
      isOpenScan: false,
    });
  }

  handleCheckAll() {
    const { itemsChecked, scanningStatus } = this.state;

    if (itemsChecked) {
      this.setState({
        itemsChecked: false,
        checkValue: [],
      });
    } else {
      const checkValue = scanningStatus
        .filter((item) => { return item.has_manage_permission; })
        .map((item) => { return item.uploaded_file_id; });

      this.setState({
        itemsChecked: true,
        checkValue,
      });
    }
  }

  handleCheckChange(e, { value }) {
    const { checkValue, scanningStatus } = this.state;

    const isValuePresent = checkValue.includes(value);

    const newState = isValuePresent
      ? checkValue.filter((el) => { return el !== value; })
      : [...checkValue, value];

    const allOrNoneChecked = newState.length === 0 || newState.length === scanningStatus.length;

    this.setState({
      checkValue: newState,
      ...(!allOrNoneChecked && { itemsChecked: false }),
    });
  }

  handleNotificationChange() {
    const { isOpenNotification } = this.state;
    this.setState({
      isOpenNotification: !isOpenNotification,
      isOpenProfile: false,
      isOpenScanList: false,
    }, () => {
      if (!isOpenNotification) {
        this.getNotificationList();
      }
    });
  }

  handleProfile() {
    const { isOpenProfile } = this.state;
    this.setState({
      isOpenProfile: !isOpenProfile,
      isOpenNotification: false,
      isOpenScanList: false,
    });
  }

  handleLocaleChange = (e, { value }) => {
    const { currentLocale } = this.state;
    if (currentLocale === value) {
      return;
    }

    this.setState({
      currentLocale: value,
    }, () => {
      this.setUserLocaleValue(value);
    });
  };

  onUpdateLoading() {
    this.setState({
      isLoading: true,
    });
  }

  onUpdateStart = () => {
    if (!this.onUpdateRunning()) {
      this.updateInterval = setInterval(this.onUpdateScanText, 7000);
    }
  };

  onUpdateStop = () => {
    if (this.onUpdateRunning()) {
      clearInterval(this.updateInterval);
      this.updateInterval = null;
    }
  };

  onUpdateNotiStart = () => {
    if (!this.updateNotiInterval) {
      this.updateNotiInterval = setInterval(this.checkIsNotification, 30000); // 30 seconds
    }
  };

  onUpdateNotiStop = () => {
    if (this.updateNotiInterval) {
      clearInterval(this.updateNotiInterval);
      this.updateNotiInterval = null;
    }
  };

  onRefreshStart() {
    this.refreshInterval = null;
    if (!this.onRefreshRunning()) {
      this.refreshInterval = setInterval(() => {
        this.onUpdateCheck();
      }, 8000);
    }
  }

  onRefreshStop() {
    clearInterval(this.refreshInterval);
    this.refreshInterval = null;
  }

  onRefreshRunning() {
    return this.refreshInterval !== null;
  }

  onUpdateRunning = () => { return this.updateInterval !== null; };

  async onUpdateCheck() {
    const { scanningStatus, pageSize, currentPage } = this.state;

    const obj = {
      page: 1,
      limit: pageSize * currentPage,
    };

    try {
      const response = await api.getScanningStatus(obj);

      if (response.status === 200) {
        const data = convertPropertiesToCamelCase(response.data.response);

        if (scanningStatus.length !== 0 && scanningStatus[0].uploaded_file_id !== data.scanningStatus[0].uploaded_file_id) {
          return this.getScanningStatus();
        }

        let newState = [...scanningStatus];

        data.scanningStatus.forEach((updatedItem) => {
          const indexInState = newState.findIndex((item) => { return item.uploaded_file_id === updatedItem.uploaded_file_id; });

          if (indexInState !== -1) {
            const itemNeedsUpdate = ['scan_status', 'scan_status_detail', 'scan_progress'].some((key) => { return newState[indexInState][key] !== updatedItem[key]; });

            if (itemNeedsUpdate) {
              newState = Update(newState, {
                $splice: [[indexInState, 1, updatedItem]],
              });
            }
          }
        });

        this.setState({
          scanningStatus: newState,
          scanningText: data.scanningText,
          count: data.pagination.count,
        });
      }
    } catch (err) {
      console.log(err);
      this.onRefreshStop();
    }
  }

  onUpdateScanText = async () => {
    try {
      const response = await api.getScanningText();
      const { text, is_show } = response.response;

      const { scanningText, isShowScanStatus } = this.state;

      if (scanningText !== text || isShowScanStatus !== is_show) {
        this.setState({
          isShowScanStatus: is_show,
          scanningText: text,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  handleRemoveReport = () => {
    const { t } = this.props;
    this.modalAction = t('modal.title.attention');
    this.modalBody = t('modal.message.delete_this_files');

    this.setState({
      isOpenPopup: true,
    });
  };

  handleScanList = (e) => {
    const { isOpenScanList, isOpenPopup } = this.state;
    if (e.target.classList[0] === 'right_button' || isOpenPopup) {
      return;
    }

    if (isOpenScanList) {
      this.setState({
        isOpenScanList: false,
        isOpenProfile: false,
        scanningStatus: [],
        count: '',
        itemsChecked: false,
        checkValue: [],
      });
    } else {
      this.setState({
        isOpenScanList: true,
        isOpenProfile: false,
        itemsChecked: false,
        checkValue: [],
      }, () => {
        this.getScanningStatus();
      });
    }
  };

  getNotificationList() {
    this.setState({
      isLoadingNoti: true,
    }, () => {
      api
        .getNotificationList()
        .then((response) => {
          const data = response.response;
          const totalCount = response.count;

          this.setState({
            notificationList: data,
            totalCount,
            isLoadingNoti: false,
            isNewNotification: false,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoadingNoti: false,
            isNewNotification: false,
          });
        });
    });
  }

  getScanningText = async () => {
    try {
      const response = await api.getScanningText();
      const { text, is_show } = response.response;

      this.setState({
        isShowScanStatus: is_show,
        scanningText: text,
      }, this.onUpdateStart);
    } catch (err) {
      console.error(err);
    }
  };

  getScanningStatus(pageNo, limit) {
    const { pageSize, scanningStatus } = this.state;
    const page = pageNo || 1;
    const perPage = limit || pageSize;

    // Simplify setting the loading state
    this.setState({
      ...(page === 1 ? { isLoading: true } : { isLoadingStatus: true }),
    });

    api.getScanningStatus({ page, limit: perPage })
      .then((response) => {
        const data = convertPropertiesToCamelCase(response.data.response);
        const isInitialPage = data.pagination.current === 1;
        const newScanningStatus = isInitialPage ? data.scanningStatus : [...scanningStatus, ...data.scanningStatus];

        this.setState({
          totalCount: data.count,
          currentPage: data.pagination.current,
          pageSize: data.pagination.per_page,
          count: data.pagination.count,
          hasMore: data.pagination.next !== null,
          scanningStatus: newScanningStatus,
          isLoading: false,
          isLoadingStatus: false,
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          isLoading: false,
          isLoadingStatus: false,
        });
      });
  }

  getUserLocaleValue() {
    const { state } = this.props;
    api
      .getUserLocaleValue()
      .then((res) => {
        const data = res.response;
        let selected;
        const newState = data.map((el) => {
          if (el.selected) {
            selected = el.locale;
          }

          return {
            text: el.name.replace(/^[a-z]/, (char) => { return char.toUpperCase(); }),
            value: el.locale,
            selected: el.selected,
          };
        });

        this.setState({
          localeList: newState,
          currentLocale: selected,
        });
        state.user.setLocaleParams(selected);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  setUserLocaleValue(value) {
    const { localeList } = this.state;
    const { i18n, state } = this.props;

    api.setUserLocaleValue({ locale: value })
      .then((res) => {
        const { locale } = res.response;
        const localeMap = { ko: 'kr', ja: 'ja', en: 'en' };
        const newLocale = localeMap[locale] || 'en';

        i18n.changeLanguage(newLocale);
        localStorage.setItem('i18nextLng', newLocale);
        state.user.setLocaleParams(locale);

        const updatedLocaleList = localeList.map((item) => {
          return {
            ...item,
            selected: item.value === locale,
          };
        });

        this.setState({
          currentLocale: locale,
          localeList: updatedLocaleList,
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  handleFilteredUploadedList = (item) => {
    const { navigate } = this.props;
    const uploadedFileIds = item.parameter
      ? item.parameter.split(',').map((val) => {
        const num = Number(val.trim());
        return isNaN(num) ? null : num;
      }).filter((val) => { return val !== null; })
      : [];

    navigate({
      pathname: '/results/overview',
      search: createSearchParams({
        uploaded_file_id: uploadedFileIds,
      }).toString()
    });
  };

  handleNavEvent = (menu) => {
    const { navigate } = this.props;
    const menuPathMap = {
      my_issue: '/my_page/issue',
      license: '/systems/license',
      oss_db: '/about',
      oss_setting: '/systems/system',
      quota: '/systems/license',
      update_required: '/systems/update',
    };

    const defaultPath = '/results/overview';

    const pathName = menuPathMap[menu] || defaultPath;

    navigate(pathName, {
      state: {
        fromList: true,
        prev: 'result',
        currentPage: 1,
      }
    });
  };

  handleScroll = (event) => {
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    const isScrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;

    const {
      error, isLoadingStatus, hasMore, currentPage
    } = this.state;

    if (error || isLoadingStatus || !hasMore) return;

    if (isScrolledToBottom) {
      this.getScanningStatus(currentPage + 1);
    }
  };

  deleteReport = () => {
    const { checkValue } = this.state;
    const { t } = this.props;
    const { state } = this.props;

    const req = {
      uploaded_ids: checkValue,
    };

    this.setState({
      isModalLoader: true,
    });

    api
      .destroySelected(req)
      .then(() => {
        state.report.setReload();
        this.setState({
          isOpenPopup: false,
          isModalLoader: false,
          checkValue: [],
          itemsChecked: false,
        }, () => {
          this.getScanningStatus();
        });
      })
      .catch((err) => {
        console.log(err);
        this.modalAction = t('modal.title.attention');
        const e = err.data.response;
        if (e.error === '422-201') {
          this.modalBody = t('modal.error.error_422_201');
        }

        if (e.error === '422-206') {
          this.modalBody = t('modal.error.error_422_206');
        }

        if (e.error === '422-366') {
          this.modalBody = e.error_description;
        }

        this.setState({
          isModalError: true,
          isModalLoader: false,
          checkValue: [],
          itemsChecked: false,
        });
      });
  };

  checkIsNotification = async () => {
    try {
      const { response } = await api.checkIsNotification();
      this.setState({
        isNewNotification: response.new_notification,
      });
    } catch (err) {
      console.error(err);
    }
  };

  closeModal() {
    this.setState({
      isOpenPopup: false,
      itemsChecked: false,
      checkValue: [],
    });
  }

  closeScanningModal() {
    this.setState({
      isOpenScanList: false,
      isOpenProfile: false,
      scanningStatus: [],
      count: '',
      itemsChecked: false,
      checkValue: [],
    });
  }

  convertToString(string) {
    if (string === 'clarityadmin@insignary.com') {
      return 'Admin';
    } if (string === 'licensemanager@insignary.com') {
      return 'Licensemanager';
    }
    return string;
  }

  renderLogo() {
    const { state } = this.props;
    if (state.user.main_page === 'dashboard') {
      return (
        <Link to="/main">
          <img src={logo} alt="" />
        </Link>
      );
    } if (state.user.main_page === 'results' || state.user.main_page === 'overview') {
      return (
        <Link to="/results/overview" reloadDocument>
          <img src={logo} alt="" />
        </Link>
      );
    }
    return (
      <Link to={`/results/${state.user.main_page}`}>
        <img src={logo} alt="" />
      </Link>
    );
  }

  render() {
    const {
      isOpenProfile,
      isShowScanStatus,
      scanningText,
      scanningStatus,
      count,
      isLoading,
      isModalError,
      itemsChecked,
      checkValue,
      isLoadingStatus,
      error,
      isNewNotification,
      isOpenNotification,
      notificationList,
      totalCount,
      isLoadingNoti,
      isOpenScanList,
      isOpenScan,
      isOpenPopup,
      isModalLoader,
      currentLocale,
      localeList,
    } = this.state;

    const { state, t } = this.props;
    const activeClassName = 'active';

    let baseUrl = '//'.concat(location.hostname);
    let profileImgUrl = '';

    if (process.env.NODE_ENV === 'development') {
      baseUrl = baseUrl.concat(':3000');
    } else {
      baseUrl = location.port !== '' ? baseUrl.concat(':', location.port) : '';
    }

    profileImgUrl = baseUrl.concat(state.user.image_thumb, '?', new Date().getTime()) || proifileImg;

    return (
      <header
        className="header_body"
        ref={this.setHeaderBodyRef}
      >
        <div className="header_box">
          <div className="header_inner">
            <h1 className="logo">{this.renderLogo()}</h1>
            <nav className="gnb">
              <NavLink to="/main" className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}>
                {t('header.dashboard')}
              </NavLink>
              <NavLink to="/results" className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}>
                {t('header.result')}
              </NavLink>
              <NavLink to="/knowledge_base" className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}>
                {t('header.knowledge_base')}
              </NavLink>
              <NavLink to="/my_page" className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}>
                {t('header.my')}
              </NavLink>
              <NavLink to="/settings" className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}>
                {t('header.settings')}
              </NavLink>
            </nav>
            <nav className="user_menu">
              <div className="user_menu_right">
                <div className="user_menu_select">
                  {isShowScanStatus ? (
                    <div className="new_scan_progress">
                      <Popup
                        trigger={(
                          <a
                            className="new_scan_progress_button"
                            onClick={this.handleScanList}
                            onKeyUp={this.handleScanList}
                          >
                            <img src={ScanProgress} alt="" className="load_icon" />
                            <span>{scanningText}</span>
                          </a>
                        )}
                        className="new_scan_popup progress_popup"
                        on="click"
                        position="bottom right"
                        open={isOpenScanList}
                        onOpen={this.handleScanList}
                        onClose={this.handleScanList}
                      >
                        <div className="popup_contents">
                          <div className="popup_contnet_right">
                            <div className="scanning_files_wrap">
                              <div className="popup_contnet_header">
                                <h3>
                                  {t('modal.new_scan.title.scanning_files')}
                                  {' '}
                                  (
                                  {count || 0}
                                  )
                                </h3>
                                <div className="button_wrap">
                                  {
                                    checkValue.length === 0 ? (
                                      <a
                                        className="delete_all_button"
                                        style={{
                                          pointerEvents: 'none',
                                          cursor: 'default',
                                          opacity: '.45',
                                        }}
                                      >
                                        <span>
                                          <img src={deleteIcon} alt="" style={{ width: '12px' }} />
                                        </span>
                                        {t('modal.button.delete')}
                                      </a>
                                    ) : (
                                      <a
                                        className="delete_all_button"
                                        onClick={this.handleRemoveReport}
                                        onKeyUp={this.handleRemoveReport}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        <span>
                                          <img src={deleteIcon} alt="" style={{ width: '12px' }} />
                                        </span>
                                        {t('modal.button.delete')}
                                      </a>
                                    )
                                  }
                                </div>
                              </div>
                              <div className="scanning_files">
                                <div className="scanning_files_header">
                                  <table className="">
                                    <colgroup>
                                      <col style={{ width: '36px' }} />
                                      <col style={{ width: '45%' }} />
                                      <col style={{ width: '54%' }} />
                                    </colgroup>
                                    <tbody>
                                      <tr>
                                        <th><Checkbox checked={itemsChecked} onChange={this.handleCheckAll} /></th>
                                        <th>{t('list.title.file_name')}</th>
                                        <th>{t('modal.title.status')}</th>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                {
                                  !isLoading ? (
                                    <div className="scanning_files_contnet">
                                      <Scrollbars
                                        renderTrackHorizontal={() => {
                                          return <div />;
                                        }}
                                        renderThumbHorizontal={() => {
                                          return <div />;
                                        }}
                                        onScroll={this.handleScroll}
                                        autoHeight
                                        autoHeightMax={265}
                                      >
                                        <table className="scanning_files_table">
                                          <colgroup>
                                            <col style={{ width: '36px' }} />
                                            <col style={{ width: '45%' }} />
                                            <col style={{ width: '54%' }} />
                                          </colgroup>
                                          <tbody>
                                            {
                                              scanningStatus.length !== 0 ? (
                                                scanningStatus.map((item) => {
                                                  if (item.scan_status === 0) {
                                                    return (
                                                      <tr key={item.uploaded_file_id}>
                                                        <td>
                                                          <Checkbox
                                                            value={item.uploaded_file_id}
                                                            checked={checkValue.indexOf(item.uploaded_file_id) > -1}
                                                            onChange={this.handleCheckChange}
                                                            disabled={!item.has_manage_permission}
                                                          />
                                                        </td>
                                                        <td>
                                                          <p className="file_name"><span>{item.name}</span></p>
                                                          <p className="project_name">
                                                            <span>{item.project_name}</span>
                                                            <span>/</span>
                                                            <span>{item.project_version_name}</span>
                                                          </p>
                                                        </td>
                                                        <td>
                                                          <p className="scan_file">
                                                            <Icon name="wait" />
                                                            {t('modal.title.scan_queued')}
                                                          </p>
                                                        </td>
                                                      </tr>
                                                    );
                                                  }
                                                  if (item.scan_status === 1) {
                                                    return (
                                                      <tr key={item.uploaded_file_id}>
                                                        <td>
                                                          <Checkbox
                                                            value={item.uploaded_file_id}
                                                            checked={checkValue.indexOf(item.uploaded_file_id) > -1}
                                                            onChange={this.handleCheckChange}
                                                            disabled={!item.has_manage_permission}
                                                          />
                                                        </td>
                                                        <td>
                                                          <p className="file_name"><span>{item.name}</span></p>
                                                          <p className="project_name">
                                                            <span>{item.project_name}</span>
                                                            <span>/</span>
                                                            <span>{item.project_version_name}</span>
                                                          </p>
                                                        </td>
                                                        <td>
                                                          <div className="progress_wrap" style={{ width: '287px' }}>
                                                            <div className="progress_info">
                                                              <span className="state">{t('modal.title.scanning')}</span>
                                                              <span className="quota">
                                                                {item.scan_progress}
                                                                % /
                                                                {' '}
                                                                {item.uploaded_size}
                                                              </span>
                                                              <span className="time">{item.scan_status_detail}</span>
                                                            </div>
                                                            <div className="progress_bar_wrap">
                                                              <Progress
                                                                percent={item.scan_progress}
                                                                //progress="percent"
                                                                size="tiny"
                                                                active={item.scan_progress >= 0 && item.scan_progress <= 100}
                                                                indicating
                                                              />
                                                            </div>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    );
                                                  }
                                                  if (item.scan_status === 3) {
                                                    return (
                                                      <tr key={item.uploaded_file_id}>
                                                        <td>
                                                          <Checkbox
                                                            value={item.uploaded_file_id}
                                                            checked={checkValue.indexOf(item.uploaded_file_id) > -1}
                                                            onChange={this.handleCheckChange}
                                                            disabled={!item.has_manage_permission}
                                                          />
                                                        </td>
                                                        <td>
                                                          <p className="file_name"><span>{item.name}</span></p>
                                                          <p className="project_name">
                                                            <span>{item.project_name}</span>
                                                            <span>/</span>
                                                            <span>{item.project_version_name}</span>
                                                          </p>
                                                        </td>
                                                        <td>
                                                          <p className="scan_file">
                                                            <Icon name="info circle" />
                                                            {t('modal.title.scan_failed')}
                                                          </p>
                                                        </td>
                                                      </tr>
                                                    );
                                                  }
                                                  return (
                                                    <tr key={item.uploaded_file_id}>
                                                      <td>
                                                        <Checkbox
                                                          value={item.uploaded_file_id}
                                                          checked={checkValue.indexOf(item.uploaded_file_id) > -1}
                                                          onChange={this.handleCheckChange}
                                                          disabled={!item.has_manage_permission}
                                                        />
                                                      </td>
                                                      -
                                                      <td>
                                                        <p className="file_name"><span>{item.name}</span></p>
                                                        <p className="project_name">
                                                          <span>{item.project_name}</span>
                                                          <span>/</span>
                                                          <span>{item.project_version_name}</span>
                                                        </p>
                                                      </td>
                                                      <td>
                                                        <div className="progress_wrap" style={{ width: '287px' }}>
                                                          <div className="progress_info">
                                                            <span className="state">{t('modal.title.uploading')}</span>
                                                            <span className="quota">
                                                              {state.report.uploadingProgress}
                                                              % /
                                                              {' '}
                                                              {item.uploaded_size}
                                                            </span>
                                                            <span className="time">-</span>
                                                          </div>
                                                          <div className="progress_bar_wrap">
                                                            <Progress
                                                              percent={state.report.uploadingProgress}
                                                              //progress="percent"
                                                              size="tiny"
                                                              active={state.report.uploadingProgress >= 0 && state.report.uploadingProgress <= 100}
                                                              indicating
                                                            />
                                                          </div>
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  );
                                                })
                                              ) : null
                                            }
                                            {error && <div className="error_log">{error}</div>}
                                            {isLoadingStatus
                                        && (
                                          <div style={{ position: 'relative' }}>
                                            <Loader size="small" active={isLoadingStatus} inline="centered" style={{ position: 'absolute', left: '288px', top: '0px' }} />
                                          </div>
                                        )}
                                          </tbody>
                                        </table>
                                      </Scrollbars>
                                    </div>
                                  ) : (
                                    <div className="scanning_files_contnet">
                                      <table className="scanning_files_table">
                                        <tbody>
                                          <tr>
                                            <Loader active inline="centered" style={{ marginTop: '16%' }}>{t('modal.message.loading')}</Loader>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  )
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </Popup>
                    </div>
                  ) : null}
                  <Dropdown
                    className="locale_select"
                    selection
                    value={currentLocale}
                    options={localeList}
                    onChange={this.handleLocaleChange}
                  />
                </div>
                <div className="user_menu_dots">
                  <Popup
                    trigger={(
                      <a
                        className={cx(
                          'notification_button',
                          {
                            noti: isNewNotification,
                          }
                        )}
                        onClick={this.handleNotificationChange}
                        onKeyUp={this.handleNotificationChange}
                      >
                        <img src={alert} alt="" />
                      </a>
                    )}
                    on="click"
                    position="bottom left"
                    style={{
                      borderRadius: '5px',
                      boxShadow: '0 2px 7px 0 rgba(0, 0, 0, 0.15)',
                      textAlign: 'left',
                    }}
                    open={isOpenNotification}
                    onClose={this.handleNotificationChange}
                  >
                    <div style={{ width: '360px' }}>
                      <div className="notification_popup">
                        <h3 className="popup_title">
                          {t('header.notification')}
                          <span className="count">{totalCount}</span>
                        </h3>
                        <Scrollbars
                          renderTrackHorizontal={() => {
                            return <div />;
                          }}
                          renderThumbHorizontal={() => {
                            return <div />;
                          }}
                          onScroll={this.handleScroll}
                          autoHeight
                          autoHeightMax={265}
                        >
                          <div className="popup_content">
                            {
                              isLoadingNoti ? (
                                <ul>
                                  <li><Loader active inline="centered" style={{ marginTop: '16%' }}>{t('modal.message.loading')}</Loader></li>
                                </ul>
                              ) : (
                                <ul>
                                  {
                                    notificationList.map((item) => {
                                      return (
                                        <li
                                          className={cx({ new: !item.is_read })}
                                          key={uuidv4()}
                                        >
                                          <div className="noti_row_wrap">
                                            <p className="noti_name">{item.message}</p>
                                            <p className="noti_date">{item.notificated_at}</p>
                                          </div>
                                          {
                                            notificationMenu.indexOf(item.menu) > -1 && (
                                              item.menu === 'uploaded_list' ? (
                                                <a
                                                  className="view_button"
                                                  onClick={() => { return this.handleFilteredUploadedList(item); }}
                                                  onKeyUp={() => { return this.handleFilteredUploadedList(item); }}
                                                >
                                                  {t('modal.button.view')}
                                                </a>
                                              ) : (
                                                <a
                                                  className="view_button"
                                                  onClick={() => { return this.handleNavEvent(item.menu); }}
                                                  onKeyUp={() => { return this.handleNavEvent(item.menu); }}
                                                >
                                                  {t('modal.button.view')}
                                                </a>
                                              )
                                            )
                                          }
                                        </li>
                                      );
                                    })
                                  }
                                  {
                                    notificationList.length === 0
                                && (
                                  <li>
                                    <p className="noti_empty">{t('modal.message.no_noti_found')}</p>
                                  </li>
                                )
                                  }
                                </ul>
                              )
                            }
                          </div>
                        </Scrollbars>
                      </div>
                    </div>
                  </Popup>
                  <Popup
                    trigger={(
                      <a
                        className="profile_button"
                        onClick={this.handleProfile}
                        onKeyUp={this.handleProfile}
                      >
                        <img src={profileBtn} alt="" />
                      </a>
                    )}
                    on="click"
                    position="bottom left"
                    style={{
                      borderRadius: '5px',
                      boxShadow: '0 2px 7px 0 rgba(0, 0, 0, 0.15)',
                      width: '215px',
                      textAlign: 'left',
                    }}
                    open={isOpenProfile}
                    onClose={this.handleProfile}
                    hideOnScroll
                  >
                    <div>
                      <div className="profile_popup_header">
                        <span className="avata">
                          <img src={profileImgUrl} alt="" />
                        </span>
                        <p className="user_name">{state.user.name}</p>
                        <p className="user_mail">{this.convertToString(state.user.email)}</p>
                      </div>
                      <div
                        className="profile_popup_menu_list"
                      >
                        <ul>
                          <li>
                            <Link to="/profile">{t('header.profile')}</Link>
                          </li>
                          <li>
                            <Link to="/systems">{t('header.system_settings')}</Link>
                          </li>
                          <li>
                            <Link to="/about">{t('header.about_clarity')}</Link>
                          </li>
                          <li>
                            <Link to="/release-notes">{t('release_note.menu')}</Link>
                          </li>
                          <li>
                            <a href={SERVICE_DESK_LINK} target="_blank" rel="noreferrer noopener">
                              {t('header.service_desk')}
                            </a>
                          </li>
                          <li>
                            <Link to="/logout">{t('header.log_out')}</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Popup>
                </div>
              </div>
            </nav>
            <ScanNavBar
              isOpenScan={isOpenScan}
              handleScanOpen={this.handleScanOpen}
              handleScanClose={this.handleScanClose}
            />
            <Modal open={isOpenPopup} onClose={this.closeModal} className="modal">
              <div className="modal_popup_wrap confirm_wrap">
                <div className="modal_popup_box confirm_box">
                  {
                    isModalLoader ? (
                      <ClarLoader />
                    ) : (
                      <div className="modal_popup confirm">
                        <h2 className="title">{this.modalAction}</h2>
                        <p className="text">{this.modalBody}</p>
                        {
                          isModalError ? (
                            <div className="button_wrap">
                              <a onClick={this.closeModal} onKeyUp={this.closeModal} className="center_button">
                                {t('modal.button.close')}
                              </a>
                            </div>
                          ) : (
                            <div className="button_wrap">
                              <a onClick={this.closeModal} onKeyUp={this.closeModal} className="left_button">
                                {t('modal.button.cancel')}
                              </a>
                              <a onClick={this.deleteReport} onKeyUp={this.deleteReport} className="right_button">
                                {t('modal.button.delete')}
                              </a>
                            </div>
                          )
                        }
                      </div>
                    )
                  }
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </header>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(Header))));
